module.exports = __webpack_public_path__ + "static/ip-62f47571b2ac96774656dfda97ab1705.svg";